import React, { FunctionComponent } from 'react';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { RenderHTML } from '../../RenderHTML';
import css from './index.module.scss';
import { useBI } from '../../../hooks/useBI';
import { pageClick } from '@wix/bi-logger-new-help-center/v2';
import { useRouter } from 'next/router';
import { BI } from '../../../constants';

export const WixStudioNotification: FunctionComponent = () => {
  const { t } = useTranslation();
  const { sendBIEvent } = useBI();
  const { locale } = useRouter();
  const wixStudioForumUrl =
    'https://forum.wixstudio.com?utm_source=cc_help_center_banner';

  const onClick = async () => {
    await sendBIEvent(
      pageClick({
        source_name: BI.SOURCE_NAMES.HOME,
        kb_lang: locale as string,
        clicked_item_type: BI.CLICKED_ITEM_TYPES.WIX_STUDIO_COMMUNITY_FORUM,
        clicked_url: wixStudioForumUrl,
        clicked_text: t('studio-forum-banner-homepage'),
        is_page_content_click: true,
      })
    );
  };

  return (
    <a
      href={wixStudioForumUrl}
      target="_blank"
      rel="noreferrer"
      className={css.wrapper}
      onClick={onClick}
    >
      <Box direction="vertical" verticalAlign="middle">
        <Text size="medium" weight="thin" skin="standard" className={css.text}>
          <RenderHTML html={t('studio-forum-banner-homepage')} />
        </Text>
      </Box>
    </a>
  );
};
